var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('div',{staticClass:"w-100"},[_c('bar-metrics',{staticClass:"sites-metrics",attrs:{"data":_vm.data,"colors":_vm.colors,"show-bars":_vm.showBars,"type":"public"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }